import { EditorView } from "@codemirror/view";

export const markdownMathTheme = EditorView.baseTheme({
    ".cm-magic-markdown-math": {
        "--cm-magic-markdown-math-accent": "var(--cm-meta-accent)",
        color: "inherit",
        fontWeight: "inherit",
        cursor: "pointer",
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--cm-magic-markdown-math-accent) 34%, transparent)",
        textUnderlineOffset: "0.16em",
    },
    ".cm-magic-markdown-math-inline": {
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "-0.08em",
        lineHeight: "inherit",
    },
    ".cm-magic-markdown-math-block": {
        display: "inline-flex",
        width: "100%",
        minHeight: "1.7em",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.15em 0",
        verticalAlign: "middle",
        textDecorationLine: "none",
    },
    ".cm-magic-markdown-math .katex": {
        color: "inherit",
        fontSize: "1em",
        lineHeight: "inherit",
    },
    ".cm-magic-markdown-math-block .katex-display": {
        display: "inline-flex",
        width: "100%",
        justifyContent: "center",
        margin: "0",
    },
    ".cm-magic-markdown-math-error": {
        color: "inherit",
        fontFamily: "var(--font-mono)",
    },
    ".cm-magic-markdown-math-hidden": {
        display: "none",
    },
    ".cm-magic-markdown-math-raw": {
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--cm-meta-accent) 28%, transparent)",
        textUnderlineOffset: "0.16em",
    },
});
